import {HierarchyType, MetricType} from 'sources/dashboard/DashMetricsSource';
import DashMetricsActions from 'actions/dashboard/DashMetricsActions';
import {showCalls} from 'utils/showCalls';
import {List} from 'immutable';

const DEFAULT_LIMIT = 200;
export function callDrillDown({
  startDate,
  endDate,
  limit = DEFAULT_LIMIT,
  hierarchy = HierarchyType.user,
  ids,
}) {
  return async stat => {
    const ruleId = stat.context;
    const statId = List([stat.id]);

    const metricsPromise = DashMetricsActions.callsForMetric({
      metric: MetricType.trigger,
      direction: null,
      hierarchy,
      ids: ids || statId,
      startDate,
      endDate,
      ruleId,
      limit,
    });

    const topicsPromise = DashMetricsActions.topicIdsForTriggerId(ruleId);

    const [metrics] = await Promise.all([metricsPromise, topicsPromise]);

    const dupes = metrics
      .groupBy(m => m.value)
      .filter(ids => ids.size > 1)
      .keySeq();
    if (!dupes.isEmpty()) console.warn('Encountered duplicate call ids:', dupes.toJS());

    const callIds = metrics.map(m => m.value).toSet();
    const callsToShow = callIds.take(limit);
    const limitWarning =
      metrics.size === limit &&
      'Only the most recent calls matching this topic are shown for performance reasons. Change the date range on the stats pane if you wish to see older matching calls.';

    const backUrl = location.pathname + location.search;
    const backText = 'Back to Topics';

    showCalls(callsToShow.toJS(), limitWarning, backUrl, backText);
  };
}
